import React, { useEffect, useState } from 'react'
import { Popup } from 'antd-mobile'
import general from '../../../general'
import Dialog from '../../../lib/Dialog'
import './css/ChatList.css'

export default function ChatList(props) {

  const [visible] = useState(props.visible)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [unreadCounts, setUnreadCounts] = useState({});
  const [init, setInit] = useState(false);

  useEffect(() => {
    getMyClusters(true)
  }, [])

  const getMyClusters = (showLoading) => {
    if (loading) {
      return
    }
    if (showLoading === true) {
      Dialog.loading()
    }
    setLoading(true)
    general.axios.post('/base/yunxin/getMyClusters', {
      "pagination": {
        "page": 1,
        "count": 100
      }
    })
      .finally(() => {
        if (showLoading === true) {
          Dialog.close()
        }
        setLoading(false)
      })
      .then(res => {
        const { data, status } = res.data
        if (status.succeed) {
          setList(data.list)
          setInit(true)
        } else {
          Dialog.error(status.error_desc)
        }
      })
      .catch((err) => {
        Dialog.error(err.message);
      })
  }

  const groupChatShareMsg = (tid) => {
    Dialog.loading()
    general.axios.post('/base/yunxin/groupChatShareMsg', {
      topic_id: props.topic_id,
      tid,
      argumentid: props.id,
      subtype: props.subtype,
      extra: props.extra || {}
    }).finally(() => {
      Dialog.close()
    })
      .then(res => {
        const { data, status } = res.data
        if (status.succeed) {
          Dialog.info('分享成功')
          close()
        } else {
          Dialog.error(status.error_desc)
        }
      })
      .catch((err) => {
        Dialog.error(err.message);
      })
  }

  const close = () => {
    if (props.close) {
      props.close()
    }
  }

  return (
    <div>
      <Popup
        visible={visible}
        bodyStyle={{
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
          height: '345px',
        }}
      >
        <div className='chat-list-index'>
          <div className="container">
            {list.map(item => {
              return (
                <div key={item.tid} className="chat-list-item" onClick={() => {
                  groupChatShareMsg(item.tid)
                }}>
                  <div className="chat-list-item-avatar">
                    <img src={item.icon} alt="" />
                  </div>
                  <div className="chat-list-item-name">{item.tname}</div>
                </div>
              )
            })}
            {list.length === 0 && init ? <div className="empty"><img src="/resources/recovery/empty.png" alt="" />暂无群聊</div> : null}
          </div>
          <div className="cancle" onClick={close}>取消</div>
        </div>
      </Popup>
    </div>
  )
}
